// src/pages/emailMarketing/UnsubscribePage.jsx
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import emailMarketingService from '../../helpers/emailMarketingService';
import Swal from 'sweetalert2';

function UnsubscribePage() {
    const { token } = useParams();
    const [confirmed, setConfirmed] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleUnsubscribe = async () => {
        setLoading(true);
        try {
            await emailMarketingService.confirmUnsubscribe(token);
            setConfirmed(true);
            Swal.fire({
                title: 'Baja confirmada',
                text: 'Has sido dado de baja exitosamente. Ya no recibirás más emails de marketing.',
                icon: 'success',
                confirmButtonText: 'Aceptar'
            });
        } catch (error) {
            Swal.fire({
                title: 'Error',
                text: error.message || 'No se pudo procesar la baja. Por favor, intenta más tarde.',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            });
        } finally {
            setLoading(false);
        }
    };

    if (confirmed) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
                <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-lg text-center">
                    <div className="text-green-500 text-6xl mb-4">✓</div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-2">Baja Confirmada</h2>
                    <p className="text-gray-600 mb-6">
                        Has sido dado de baja exitosamente. Ya no recibirás más emails de marketing.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
            <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-lg text-center">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Confirmar Baja</h2>
                <p className="text-gray-600 mb-6">
                    ¿Estás seguro de que deseas darte de baja? Ya no recibirás más emails de marketing.
                </p>
                <button
                    onClick={handleUnsubscribe}
                    disabled={loading}
                    className="w-full bg-red-500 text-white px-6 py-3 rounded-lg hover:bg-red-600 transition-colors disabled:opacity-50"
                >
                    {loading ? 'Procesando...' : 'Confirmar Baja'}
                </button>
            </div>
        </div>
    );
}

export default UnsubscribePage;

